import React from 'react';
import { Button, Tooltip } from 'antd';
import { SystemType as SystemTypeResponse } from '@/DTOS/SystemType/Response/SytemType';
import { EditOutlined} from '@ant-design/icons';


export const SystemTypeColumn = (
  handleEdit: (record: SystemTypeResponse) => void
) => [
  
  {
    title: 'System Type Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 200,
    render: (isActive: boolean) => (isActive ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: SystemTypeResponse) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button> 
     </Tooltip>
    ),
    width: 120,
    fixed: 'right',
  },
];
